import React, { createContext, useContext } from 'react';
import mockData from '../mock';
// Create a context
const { DigitalWall } = mockData;
const DataContext = createContext();

// Create a context provider component
export const DataProvider = ({ children }) => {
    return (
        <DataContext.Provider value={DigitalWall}>
            {children}
        </DataContext.Provider>
    );
};

// Custom hook to consume the context
export const useMockData = () => {
    return useContext(DataContext);
};
